export default __webpack_public_path__ + "static/media/ag-dropdown.5e6b28bf.webp";